import { tickerItems } from "@/mocks/home";
import Reveal from "./Reveal";

const stats = [
  { value: "900+", label: "归档合集" },
  { value: "320w+", label: "累计浏览" },
  { value: "24h", label: "热榜滚动" },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[560px] flex-col overflow-hidden md:min-h-[640px]"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=abstract%20editorial%20composition%20of%20layered%20glossy%20magazine%20paper%20ribbons%20and%20bold%20red%20typography%20over%20deep%20maroon%20background%20with%20warm%20amber%20spotlight%20and%20subtle%20film%20grain%2C%20premium%20journalistic%20media%20aesthetic&width=1600&height=900&seq=gua-hero-bg&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/60"></div>

      <div className="container-gua relative flex flex-1 flex-col items-center justify-center py-28 text-center md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-black/30 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200">
          <span className="flex h-2 w-2 items-center justify-center">
            <i className="ri-flashlight-line text-sm text-accent-300"></i>
          </span>
          每周三更 · 热点持续归档，历史全收录
        </span>

        <h1 className="mt-7 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          全网热点，<span className="text-accent-300">一次看全</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
          呱呱爆料为你整理经典爆料合集与精华汇总，按时间线梳理事件脉络，历史记录与名场面一网打尽，不错过任何一个关键细节。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <a
            href="#hot"
            className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-fire-line text-lg"></i>
            进入今日热榜
          </a>
          <a
            href="#download"
            className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md border border-background-50/60 bg-white/5 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition hover:bg-white/15"
          >
            <i className="ri-file-download-line text-lg"></i>
            下载精华合集
          </a>
        </div>

        <div className="mt-11 flex items-center gap-8 md:gap-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {s.value}
              </div>
              <div className="mt-1 text-xs text-background-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ticker */}
      <div className="relative flex items-stretch">
        <div className="z-10 flex items-center gap-2 bg-primary-600 px-4 py-2.5 text-background-50">
          <i className="ri-focus-3-line text-lg"></i>
          <span className="whitespace-nowrap text-sm font-bold tracking-wide">热点快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden bg-black/40 backdrop-blur-sm">
          <div className="gua-marquee flex w-max items-center py-2.5">
            {[...tickerItems, ...tickerItems].map((item, idx) => (
              <span
                key={idx}
                className="mx-6 inline-flex items-center gap-2 whitespace-nowrap text-sm text-background-100"
              >
                <i className="ri-sparkling-2-line text-xs text-accent-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}